import { Pipe, PipeTransform } from '@angular/core';
import { Price } from '@markant-platform/cartridge/model';
import { isBulkPrice } from '@markant-platform/shared/util-helpers';
import { BackofficePrice } from '@markant-platform/shared/backoffice/model';

@Pipe({ name: 'isBulkPrice', standalone: true })
export class IsBulkPricePipe implements PipeTransform {
  transform(price: Price | BackofficePrice | undefined): boolean {
    return isBulkPrice(price);
  }
}
